export const extractTimeStampLatLongValuesFromURL = (url: string) => {
  const file = url.substring(url.lastIndexOf("/") + 1, url.indexOf("?"));
  const [, timestamp, latitude, longitude] = file.split("_");
  return { 
    timestamp, 
    latitude: latitude || undefined, 
    longitude: longitude || undefined,
    file 
  };
};
